import { useEffect } from 'react';

// Loads the Crisp chat widget when a Website ID is available (fetched at runtime
// from /public-config, so it can be set from the owner-admin panel with no
// rebuild; falls back to the REACT_APP_CRISP_WEBSITE_ID build var). Keeps the
// visitor identity in sync with the signed-in user. No-op without an ID.
export default function useCrisp(user, crispId) {
  const CRISP_ID = crispId || process.env.REACT_APP_CRISP_WEBSITE_ID;

  // Inject the loader once an ID is known.
  useEffect(() => {
    if (!CRISP_ID || window.$crisp) return;
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = CRISP_ID;
    const s = document.createElement('script');
    s.src = 'https://client.crisp.chat/l.js';
    s.async = 1;
    document.head.appendChild(s);
  }, [CRISP_ID]);

  // Push user identity whenever it changes.
  useEffect(() => {
    if (!CRISP_ID || !window.$crisp) return;
    const name = user?.employee?.name || user?.username;
    if (user?.email) window.$crisp.push(['set', 'user:email', [user.email]]);
    if (name) window.$crisp.push(['set', 'user:nickname', [name]]);
    if (user?.workspace?.name) {
      window.$crisp.push(['set', 'session:data', [[['workspace', user.workspace.name], ['role', user.role || '']]]]);
    }
  }, [user, CRISP_ID]);
}
